import "@/App.css";
import "@/i18n";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PrefsProvider } from "@/context/PrefsContext";
import { DirtyGuardProvider } from "@/context/DirtyGuard";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { ScrollToTop } from "@/routes/ScrollToTop";
import { publicRoutes } from "@/routes/publicRoutes";
import { accountingRoutes } from "@/routes/accountingRoutes";
import { salesRoutes } from "@/routes/salesRoutes";
import { purchaseRoutes } from "@/routes/purchaseRoutes";
import { APP_ROUTES } from "@/routes/appRoutes";
import { SplashScreen } from "@/components/layout/SplashScreen";
import { OfflineNotice } from "@/components/layout/OfflineNotice";
import { PushSync } from "@/components/layout/PushSync";
import { CalendarSync } from "@/components/layout/CalendarSync";
import { ReportOverlayHost } from "@/features/reports/ReportOverlayHost";
import { IS_STORE_BUILD, PURCHASE_ROUTES } from "@/config/storeBuild";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PrefsProvider>
            <DirtyGuardProvider>
            <ScrollToTop />
            <SplashScreen />
            <OfflineNotice />
            <PushSync />
            <CalendarSync />
            <ReportOverlayHost />
            <Toaster
              position="top-center"
              offset="calc(env(safe-area-inset-top) + 88px)"
              mobileOffset={{ top: "calc(env(safe-area-inset-top) + 80px)", left: "12px", right: "12px" }}
              gap={10}
              style={{ "--width": "min(680px, calc(100vw - 24px))" }}
              toastOptions={{
                unstyled: true,
                classNames: {
                  toast:
                    "neu flex w-full max-w-[680px] items-center justify-between gap-3 rounded-3xl px-4 py-3.5 text-sm font-bold text-foreground",
                  title: "flex-1 text-sm font-bold leading-snug",
                  description: "text-xs font-semibold text-muted-foreground",
                  icon: "shrink-0",
                  success: "text-primary",
                  error: "text-destructive",
                  closeButton: "neu-in rounded-full",
                },
              }}
            />
            <Routes>
              {publicRoutes}
              {accountingRoutes}
              {salesRoutes}
              {purchaseRoutes}
              {APP_ROUTES.map(({ path, element, roles }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    IS_STORE_BUILD && PURCHASE_ROUTES.includes(path) ? (
                      <Navigate to="/" replace />
                    ) : (
                      <ProtectedRoute roles={roles}>{element}</ProtectedRoute>
                    )
                  }
                />
              ))}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            </DirtyGuardProvider>
          </PrefsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
